// extracted by css-extract-rspack-plugin
export default {"contentsHead":"Edit__contentsHead--sl9Qv","contentsHeadButtonWrap":"Edit__contentsHeadButtonWrap--Ozxof"};